import { hasEmoji, hasSpecialCharacters } from "./stringValidityCheck";

const MIN_USERNAME_LENGTH = 2;
const MAX_USERNAME_LENGTH = 24;

interface UsernameValidityResult {
  isValid: boolean;
  message: string;
}

export function checkUsernameValidity(
  username: string
): UsernameValidityResult {
  let message = "";
  let isValid = true;

  if (username.length === 0) {
    return {
      isValid: false,
      message: "",
    };
  }

  if (
    username.length < MIN_USERNAME_LENGTH ||
    username.length > MAX_USERNAME_LENGTH
  ) {
    message = `Username must be between ${MIN_USERNAME_LENGTH} and ${MAX_USERNAME_LENGTH} characters`;
    isValid = false;
  }

  if (hasEmoji(username)) {
    message = "Username cannot contain emojis";
    isValid = false;
  }

  if (hasSpecialCharacters(username)) {
    message = "Username can only contain letters and numbers";
    isValid = false;
  }

  return {
    isValid,
    message,
  };
}
